/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacySatudoraECOperatorListItem,
  PharmacySatudoraECOperatorListItemFromJSON,
  PharmacySatudoraECOperatorListItemFromJSONTyped,
  PharmacySatudoraECOperatorListItemToJSON,
} from "./";

export const GetSatudoraECOperatorResponseTypename = "GetSatudoraECOperatorResponse" as const;

/**
 *
 * @export
 * @interface GetSatudoraECOperatorResponse
 */
export interface GetSatudoraECOperatorResponse {
  /**
   *
   * @type {PharmacySatudoraECOperatorListItem}
   * @memberof GetSatudoraECOperatorResponse
   */
  satudoraEcOperator: PharmacySatudoraECOperatorListItem;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetSatudoraECOperatorResponse
   */
  readonly __typename?: string;
}

export function GetSatudoraECOperatorResponseFromJSON(json: any): GetSatudoraECOperatorResponse {
  return GetSatudoraECOperatorResponseFromJSONTyped(json, false);
}

export function GetSatudoraECOperatorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSatudoraECOperatorResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetSatudoraECOperatorResponseTypename,

    satudoraEcOperator: PharmacySatudoraECOperatorListItemFromJSON(json["satudora-ec-operator"]),
  };
}

export function GetSatudoraECOperatorResponseToJSON(object?: GetSatudoraECOperatorResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    "satudora-ec-operator": PharmacySatudoraECOperatorListItemToJSON(value.satudoraEcOperator),
  };
}
